import { Component, OnInit, Pipe, ViewChild } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faEdit,
  faQuestionCircle,
  faLightbulb,
  faFileExport,
  faInfoCircle,
  faLifeRing,
  faBrain,
  faLink,
  faSitemap,
  faLock,
  faPlus,
  faProjectDiagram,
  faRedo,
  faSave,
  faSearch,
  faStepBackward,
  faStepForward,
  faTasks,
  faTimes,
  faTrashAlt,
  faUser,
  faBug,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { EditorChangeContent, EditorChangeSelection, Focus } from 'ngx-quill';
import { MainComponent } from '../main/main.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { PlannerComponent } from '../planner/planner.component';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
declare var $: any;
import { UserManagementService } from '../shared/services/user-management.service';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { EntityTestCoverageComponent } from '../entity-test-coverage/entity-test-coverage.component';

@Component({
  selector: 'app-entity-test',
  templateUrl: './entity-test.component.html',
  styleUrls: ['./entity-test.component.scss'],
  providers: [EntityTestCoverageComponent]
})
export class EntityTestComponent implements OnInit {
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faSitemap = faSitemap;
  faAngleRight = faAngleRight;
  faLifeRing = faLifeRing;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faTimesCircle = faTimesCircle;
  faLightbulb = faLightbulb;
  faBrain = faBrain;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faThumbsUp = faThumbsUp;
  faInfoCircle = faInfoCircle;
  faConnectdevelop = faConnectdevelop;
  faLink = faLink;
  faTrashAlt = faTrashAlt;
  faCircle = faCircle;
  faThumbsDown = faThumbsDown;
  faCheckCircle = faCheckCircle;
  faRedo = faRedo;
  faSave = faSave;
  faPlus = faPlus;
  faTrash = faTrash;
  faSearch = faSearch;
  faLock = faLock;
  faBug = faBug;
  faTimes = faTimes;
  faEdit = faEdit;
  faTasks = faTasks;
  jiraProjectData: any;
  index: any = 0;
  totalNotificationCount: any = 0;
  nextCount: any = 0;
  prevCount: any = 0;
  showText = false;
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  selectedEUT: any = '';
  selectedEUTType: any = 'TF';
  selectedmodule: any = {};
  newEUTname: any = '';
  searchText: any = '';
  currentTab: any = 'import';
  selectedDeleteScenEid: any = '';
  modelData: any;
  config: any;
  selectedEntity: any = '';
  selectedEntityObj: any;
  selectedEditEntity: any;
  errorMessage: any = '';
  selectedTestType: any = { "symbol": '', "desc": '' };
  selectedTest: any = {};
  entityName: any = '';
  mapText: any = '';
  updatedmapText: any = '';
  newscenariolevel: any = '';
  persona: any = [];
  attribute: any = [];
  interaction: any = [];
  selectedEntityIDDetails: any;
  editorContent: any = '';
  editorContentText: any = '';
  selectedString: any;

  designereditorContent: any = '';
  designereditorContentText: any = '';
  designerselectedString: any;
  entityScenarios: any = '';
  newPersona: any = '';
  message: any = '';
  attributeSelected: any = [];
  personaSelected: any = [];
  levelSelected: any = [];
  crSelected: any = [];
  newscenarioattr: any = '';
  newscenariosymbol: any = 'Fe';
  newscenariocr: any = '+';
  newscenariopriority: any = '1';
  newscenariodesc: any = '';
  editscenariodesc: any = '';
  newscenariopersona: any = [];
  editScenario: any = '';
  selectedEntityeID: any = '';
  newCreatedID: any = '';
  duplicateEntity: any = '';
  selectedOldEntity: any;
  notesEditorContent: any;
  designerNotesEditorContent: any;
  testTypeDesc: any = '';
  selectedEditorAttribute = { symbol: 'Mi', name: 'Migration' };
  selectedEditorAttr: any = {};
  selectedEditorLevel: any = 'L8';
  matchedScenario: any = '';
  duplicateScenario: any = '';
  testTypes: any = [
    {
      name: 'Feature Behaviour',
      symbol: 'Fe',
      eType: 'TF',
    },
    {
      name: 'Requirement Behaviour',
      symbol: 'Rb',
      eType: 'UR',
    },
    {
      name: 'Flow Behaviour',
      symbol: 'Fb',
      eType: 'BF',
    },
  ];
  EntityType: any = false;
  primaryEntity = true;
  choosenEUT: any = { "eName": '' };
  eutTypes = ['TF', 'UR', 'BF'];
  types = ["NEW", "MOD", "FIX"];
  entityTypes = ["XX", "TF", "UR", "BF"];
  choosenType = 'NEW';
  choosenEntityType = 'UR';
  choosenPrimaryeName: any = ''
  choosenPrimaryEntity = {
    "eName": '',
    "eID": ''
  };
  choosenModule = {
    "mName": '',
    "mID": ''
  };
  scenarioTypes = ['+', '-'];
  selectedAddEUT = 'TF';
  loginDetails: any;
  addNewEntityModel: any = '';
  eut: any;
  build: any;
  selectedEnvironment: any;
  envMapArrayList: any = [];
  selectEnvSubstr: any = '';
  scenarioEmpty: any;
  mappedAttributes: any;
  scenarioStatusTestTypes: any = [];
  entityScenarioNill: boolean = false;
  entityScenarioOne: boolean = false;
  entityScenarioAll: boolean = false;
  mindMapData: any = '';
  nodeData: any = '';
  summaryTypes = ["By Test", "By Level", "By Type"];
  selectedEntityScenarios: any = [];
  selectedEntityScenarioTestTypes: any = [];
  childrenArray: any = [];
  levelwiseCount: any = [{ "level": "L8", "count": 0 }, { "level": "L7", "count": 0 }, { "level": "L6", "count": 0 }, { "level": "L5", "count": 0 }, { "level": "L4", "count": 0 }, { "level": "L123", "count": 0 }];
  TypeswiseCount: any = [{ "type": "+", "count": 0 }, { "type": "-", "count": 0 }];
  TestTypewiseCount: any = [{ "test": "Fe", "name": "Feature Behaviour", "count": 0 }, { "test": "Rb", "name": "Requirement Behaviour", "count": 0 }, { "test": "Fb", "name": "Flow Behaviour", "count": 0 }, { "test": "Ls", "name": "Load & Stress", "count": 0 }, { "test": "Pf", "name": "Performance", "count": 0 }, { "test": "Se", "name": "Security", "count": 0 }, { "test": "Us", "name": "Usability", "count": 0 }, { "test": "Cm", "name": "Compatibility", "count": 0 }, { "test": "Vo", "name": "Volume", "count": 0 }, { "test": "Re", "name": "Reliability", "count": 0 }, { "test": "Mi", "name": "Migration", "count": 0 }];
  resultArrays: any = [];
  finalResultArray: any = [];
  filteredText: any;
  syncModelDataObject: any;
  selectedEntityNotes: any;
  mapTextCoverage: any;
  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private Config: Config,
    private MainComponent: MainComponent,
    private cookieService: CookieService,
    private reloadToolService: ReloadToolService,
    private AppService: AppService,
    public translate: TranslateService,
    private EntityTestCoverageComponent: EntityTestCoverageComponent,
  ) { }

  ngOnInit(): void {
    this.config = this.Config;
    this.modelData = this._sharedService.loadedProjectData.model;
    this.envMapListGenerate();
    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.selectedEditorAttr = this.config.listOfTestTypes.find(
      (att: any) => att.symbol == this.selectedEditorAttribute.symbol
    );
    // this.getMynotesData();
    setTimeout(() => {
      this.changeTab('description');
    }, 500);
    this.selectModule(this.modelData.modules[0]);
    this.selectTest(this.config.listofFunctionalityTestTypes[0]);
    this.reloadToolService.triggerSmartChecklist('');
    window.localStorage.removeItem("entityTestName");
  }
  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  openSmartChecklist() {
    // this.reloadToolService.triggerSmartChecklist('la');
    var activeChecklist = window.localStorage.getItem("entityTestChecklist");

    if (activeChecklist) {
      window.localStorage.removeItem('entityTestChecklist');
      $(".autoCursor").removeClass('checklistIcon');
    } else {
      window.localStorage.setItem('entityTestChecklist', "la");
      $(".autoCursor").addClass('checklistIcon');
    }

  }
  openChatGPTassist(tool: any) {
    this.MainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", tool);
    setTimeout(() => {
      if (this.choosenEUT) {
        this.loadEntityDetails(this.choosenEUT);
      }
    }, 500);
  }
  envMapListGenerate() {
    this.selectEnvSubstr = '';
    this.envMapArrayList = [];
    for (var i = 0; i < this.modelData.envMap.length; i++) {
      for (var j = 0; j < this.modelData.envMap[i].envList.length; j++) {
        // var obj: any = {};
        var envSubstr = this.modelData.envMap[i].envName.substring(0, 2);
        var envCode = envSubstr.toUpperCase();
        let envname =
          envCode +
          '1.' +
          (j + 1) +
          '(' +
          this.modelData.envMap[i].envList[j] +
          ')';
        // obj['name'] = envname;
        // obj['value'] = this.modelData.envMap[i].envList[j];
        let obj: any = {
          name: envname,
          value: this.modelData.envMap[i].envList[j],
        };
        this.envMapArrayList.push(obj);
      }
    }
  }
  selectEutType(eut: any) {
    this.selectedEUTType = eut;
  }
  selectModule(module: any) {
    this.selectedmodule = module;
    this.clearEntityDetails();
  }
  selectEut(eut: any) {
    // alert(eut);
    this.selectedAddEUT = eut;
  }
  changeTab(tabName: any) {
    this.currentTab = tabName;
  };
  chooseeType(eType: any) {
    this.choosenEntityType = eType;
  }
  chooseType(type: any) {
    this.choosenType = type;
    if (this.modelData.listOfBaseEUTs.length > 0) {
      if (type == 'MOD' || type == 'FIX') {
        this.primaryEntity = false;
      } else {
        this.primaryEntity = true;
      }
    }
    if (this.modelData.listOfBaseEUTs.length == 0) {
      this.primaryEntity = true;
    }
    this.choosenPrimaryEntity = {
      "eName": '',
      "eID": ''
    };
    // this.choosePrimaryEUT(this.modelData.listOfEUTs[0]);
  }
  choosePrimaryEUT(eut: any) {
    if (eut == '') {
      this.choosenPrimaryEntity.eName = 'anonymous'
    } else {
      this.choosenPrimaryEntity = eut;
      this.choosenPrimaryeName = eut.eName;
    }
  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  clear() {
    this.showText = false;
    // this.mapText = '';
    this.editorContent = '';
    this.selectedEntityIDDetails = '';
    this.EntityType = false;

  }
  selectBuild(num: any) {
    this.build = num;
  }
  chooseEnvironment(name: any) {
    this.selectedEnvironment = name;
  }

  //update the run status for a particular scenario
  updateStatus(scenarioID: any, status: any) {
    for (var i = 0; i < this.modelData.runInfo.length; i++) {
      if (
        this.modelData.runInfo[i].scenID == scenarioID &&
        this.modelData.runInfo[i].buildID == this.build
      ) {
        this.modelData.runInfo[i].status = status;
        return status;
      }

    }

  }
  //getting the run status for a particular scenario
  getStatus(scenarioID: any) {

    if (this.build) {
      var runData = this.modelData.runInfo.find(
        (aRun: any) => aRun.scenID == scenarioID && aRun.buildID == this.build
      );
      if (runData) {
        if (runData.status == '') {
          return 'N';
        } else {
          return runData.status;
        }
      } else {
        this.addRun(scenarioID, this.build, status, this.selectedEnvironment);
        return 'N';
      }
    }
    return status;
  }
  addRun(scenID: any, build: any, status: any, env: any) {
    var aRun = {
      scenID: scenID,
      buildID: build,
      status: status,
      outcome: 'P',
      timeStamp: new Date(),
      environment: env,
    };
    this.modelData.runInfo.push(aRun);
    // console.log(this.modelData);
  }
  //getting the run outcome for a particular scenario
  getOutcome(scenarioID: any) {
    var runData = this.modelData.runInfo.find(
      (aRun: any) => aRun.scenID == scenarioID && aRun.buildID == this.build
    );
    if (runData) {
      return runData.outcome;
    }
  }

  //update the run outcome for a particular scenario
  updateOutcome(scenarioID: any, outcome: any) {
    var runData = this.modelData.runInfo.find(
      (aRun: any) => aRun.scenID == scenarioID && aRun.buildID == this.build
    );
    if (runData) {
      runData.outcome = outcome;
    }
  }
  addPersona() {
    let newPersona = this.newPersona;
    if (newPersona) {
      for (var i = 0; i < this.modelData.persona.length; i++) {
        if (
          this.modelData.persona[i].pName.toLowerCase() ==
          newPersona.toLowerCase()
        ) {
          this.duplicateEntity = newPersona;
          this.errorMessage = "Already exists!";
          $('#duplicateErrorMessagePopupModel').modal('show');
          this.newPersona;
          return;
        }
      }
      var newPersonaObj = {
        pName: newPersona,
        pType: this.uniqueID('P'),
      };
      this.modelData.persona.unshift(newPersonaObj);
      this.syncModelDataObject = {
        "type": "PERSONA",
        "operation": "CREATE",
        "data": newPersonaObj
      }
      this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
      this.clearAddPersona();
    } else {
      this.errorMessage = "Persona can't be empty.";
      $('#duplicateErrorMessagePopupModel').modal('show');
      this.clearAddPersona();
    }

  }

  clearAddPersona() {
    this.newPersona = '';
  }
  updatedEntity() {
    this.showText = true;
    this.newEUTname = this.selectedEUT.eName;
    this.EntityType = false;
  }

  AddNewEUT(newEut: any) {
    this.showText = newEut;
    this.selectedEntity = '';
    this.selectedEUT = '';
    this.EntityType = false;
    this.mapText = '';
    this.editorContent = '';
    this.newEUTname = '';
    this.selectedEntityeID = '';
    this.selectedEntityIDDetails = '';
    window.localStorage.setItem("maptext", '');
    // this.clear();
  }


  //adding  a new entity
  addEntityNew() {
    let newEntity = this.newEUTname;
    var entityCount = 0;
    for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
      if (
        this.modelData.listOfEUTs[i].eName.toLowerCase() ==
        this.newEUTname.toLowerCase() && this.modelData.listOfEUTs[i].mID == this.selectedmodule.mID
      ) {
        entityCount++;
        this.duplicateEntity = "'" + this.newEUTname + "'";
        if (this.selectedEUT) {
          if (this.modelData.listOfEUTs[i].eID == this.selectedEUT.eID) {
            entityCount--;
          }
        }
      }
    }

    if (this.selectedEUT.eID) {
      if (newEntity) {
        if (entityCount > 0) {
          this.errorMessage = 'Already exists!';
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
            if (
              this.modelData.listOfEUTs[j].eID == this.selectedEUT.eID
            ) {
              this.selectedOldEntity = this.modelData.listOfEUTs[j].eName;
              this.modelData.listOfEUTs[j]['eName'] = newEntity;
              this.modelData.listOfEUTs[j]['eType'] = this.choosenEntityType;
              this.modelData.listOfEUTs[j]['stage'] = this.choosenType;
              this.modelData.listOfEUTs[j]['mID'] = this.selectedmodule.mID;
              this.modelData.listOfEUTs[j]['base_eID'] = this.choosenPrimaryEntity.eID;
              this.syncModelDataObject = {
                "type": "ENTITY",
                "operation": "UPDATE",
                "data": this.modelData.listOfEUTs[j]
              }
              this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);

              this.clear();
              this.loadEntityDetails(this.modelData.listOfEUTs[j]);
              return;
            }
          }
          // return;
          // this.loadEntityDetails(this.modelData.listOfEUTs[j]);
        }
      } else {
        this.duplicateEntity = this.selectedEUT.eName;
        this.errorMessage = 'Would you like to delete?';
        $('#deleteLandscaperEntityErrorMessagePopupModel').modal('show');
        return;
      }
    } else {
      if (newEntity) {
        if (entityCount > 0) {
          this.errorMessage = 'Already exists!';
          // this.model.errorMessage = this.AppService.getResourceText("V031");
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          this.createNewEUT(newEntity, this.selectedEUTType);
        }
      } else {
        this.errorMessage = "Entity can't be empty.";
        $('#duplicateErrorMessagePopupModel').modal('show');
      }
    }


    // }
    this.selectedEUT = '';
    this.newEUTname = '';
    $('#entitytextarea').val('');
  }
  scenariosStatus() {
    if (this.selectedEntityIDDetails) {
      this.entityScenarioNill = true;
      this.entityScenarioOne = false;
      this.entityScenarioAll = false;
      var foundEntityDetails = this.modelData.EUTdetails.find((entity: any) => entity.eID == this.selectedEntityIDDetails.eID)
      if (foundEntityDetails) {
        if (foundEntityDetails.testTypes) {
          var entityTestTypes = foundEntityDetails.testTypes;
          var scenarioCount = 0
          var scenariosFound = true;
          for (var i = 0; i < entityTestTypes.length; i++) {
            for (var j = 0; j < this.modelData.scenarios.length; j++) {
              if (entityTestTypes[i].symbol == this.modelData.scenarios[j].attribute.symbol) {
                scenarioCount++;
              }
            }
            var scenarioFound = this.modelData.scenarios.find((scenario: any) => scenario.attribute.symbol == entityTestTypes[i].symbol)
            if (!scenarioFound) {
              scenariosFound = false;
            }
          }
          if (scenariosFound == true) {
            if (scenarioCount > 0) {
              this.entityScenarioNill = false;
              this.entityScenarioOne = true;
              this.entityScenarioAll = false;
            } else {
              this.entityScenarioNill = true;
              this.entityScenarioOne = false;
              this.entityScenarioAll = false;
            }
          } else {
            this.entityScenarioNill = false;
            this.entityScenarioOne = false;
            this.entityScenarioAll = true;
          }

        }
      }
    }
  }
  updateTestTypeStatus() {
    if (this.selectedEntity) {
      var foundEntityDetails = this.modelData.EUTdetails.find((entity: any) => entity.eID == this.selectedEntity.eID)

      this.scenarioStatusTestTypes = [];
      this.scenarioStatusTestTypes = this.testTypes.concat(this.config.listOfAttributesUpdated);

      for (var i = 0; i < this.scenarioStatusTestTypes.length; i++) {


        if (foundEntityDetails.testTypes) {

          var fountTestType = foundEntityDetails.testTypes.find((test: any) => this.scenarioStatusTestTypes[i].symbol == test.symbol)
          if (fountTestType) {
            this.scenarioStatusTestTypes[i]['satisfy'] = true;
          } else {
            this.scenarioStatusTestTypes[i]['satisfy'] = false;
          }
        } else {
          this.scenarioStatusTestTypes[i]['satisfy'] = false;
        }

        if (this.scenarioStatusTestTypes[i].symbol == "Fe" || this.scenarioStatusTestTypes[i].symbol == "Rb" || this.scenarioStatusTestTypes[i].symbol == "Fb") {
          this.scenarioStatusTestTypes[i]['satisfy'] = true;
        }
        var foundScenario = this.modelData.scenarios.find((scenario: any) => scenario.attribute.symbol == this.scenarioStatusTestTypes[i].symbol && scenario.eID == this.selectedEntity.eID)
        if (foundScenario) {
          this.scenarioStatusTestTypes[i]['stated'] = true;
        } else {
          this.scenarioStatusTestTypes[i]['stated'] = false;
        }
      }
    }
  }
  createNewEUT(newEntity: any, entityType: any) {
    var newEntityObj = {
      //eid is the unique id generated for an entity,etype being the type ->tf,bf,fl
      eID: this.uniqueID(this.choosenEntityType),
      eType: this.choosenEntityType,
      eName: newEntity,
      mID: this.selectedmodule.mID,
      stage: this.choosenType,
      base_eID: this.choosenPrimaryEntity.eID
    };
    this.modelData.listOfEUTs.unshift(newEntityObj);
    this.syncModelDataObject = {
      "type": "ENTITY",
      "operation": "CREATE",
      "data": newEntityObj
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.generateTasks(newEntityObj);
    this.clear();
    this.loadEntityDetails(newEntityObj);
  }
  generateTasks(entity: any) {
    let taskCombineUUID: any = this.uuidv4();
    let assignedUser: any;
    // if (this.modelData.invites.length > 1) {
    assignedUser = {
      "id": '',
      "name": ''
    }
    // } else {
    //   assignedUser = {
    //     "id": this.loginDetails.userId,
    //     "name": this.loginDetails.user_display_name
    //   }
    // }
    let taskCreateArray: any = '';
    if (entity.stage == 'NEW') {

      if (this.choosenEntityType == 'UR') {
        taskCreateArray = ['pm', 'sc', 'im', 'dd'];
      } else {
        taskCreateArray = ['sc', 'im', 'dd'];
      }

    } else if (entity.stage == 'MOD') {
      taskCreateArray = ['dd', 'de', 'ex', 'bex'];
    } else if (entity.stage == 'FIX') {
      taskCreateArray = ['de', 'ex', 'bex'];
    }

    for (var i = 0; i < taskCreateArray.length; i++) {
      this.generateTaskObj(entity, taskCombineUUID, assignedUser, taskCreateArray[i], this.choosenPrimaryEntity.eID);
    }
  }

  generateTaskObj(entity: any, taskCombineUUID: any, assignedUser: any, toolType: any, primaryEntityID: any) {
    let taskObj: any = {};
    taskObj.task_combine_id = taskCombineUUID;
    taskObj.assignedto = assignedUser.id;
    taskObj.assigneduser = assignedUser.name;

    // taskObj.attribute = attribute;
    // taskObj.activity = { type: 'RI', name: 'IMP' };
    // taskObj.environment = this.model.choosenEntity.environment;
    if (entity.stage == 'MOD' || entity.stage == 'FIX') {
      var attribute: any = {};
      if (entity.eType == "TF" || entity.eType == "XX") {
        attribute = {
          name: "Feature Behaviour",
          symbol: "Fe",
          level: "L4"
        };
      } else if (entity.eType == "UR") {
        attribute = {
          name: "Requirement Behaviour",
          symbol: "Rb",
          level: "L5"

        };
      } else if (entity.eType == "BF") {
        attribute = {
          name: "Flow Behaviour",
          symbol: "Fb",
          level: "L5"
        };
      }
      // var primaryEntity = this.modelData.tasks.find((eut: any) => (eut.entity_Id == primaryEntityID && eut.toolType == 'ex'));
      taskObj.baseEntity_Id = this.choosenPrimaryEntity.eID;
      var primaryEntity = { "eName": "Anonymous" };
      if (this.choosenPrimaryEntity.eID) {
        primaryEntity = this.modelData.listOfBaseEUTs.find((eut: any) => eut.eID == this.choosenPrimaryEntity.eID);
      }
      if (toolType == 'bex') {
        taskObj.task_desc = '(re)' + this.generateTaskDesc(toolType, primaryEntity.eName, attribute.name, this.selectedmodule.mName);
      } else {
        taskObj.task_desc = '(re)' + this.generateTaskDesc(toolType, entity.eName, attribute.name, this.selectedmodule.mName);
      }
      taskObj.attribute = attribute;
      taskObj.activity = { type: 'RM', name: 'Re-test', shortfrom: 'R-Test' };
    } else {
      taskObj.task_desc = this.generateTaskDesc(toolType, entity.eName, '', this.selectedmodule.mName);
      taskObj.activity = { type: 'TN', name: 'Test', shortfrom: 'Test' };
    }
    taskObj.toolType = toolType;
    taskObj.moduleName = this.selectedmodule.mName;
    taskObj.moduleID = this.selectedmodule.mID;
    taskObj.entity_Id = entity.eID;
    taskObj.entity_desc = entity.eName;
    taskObj.entityType = entity.eType;
    taskObj.primaryentity_Id = "";
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.status = 1;
    taskObj.taskId = this.uuidv4();
    taskObj.createdOn = new Date();
    // console.log("taskObj", taskObj);
    this.modelData.tasks.push(taskObj);
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "CREATE",
      "data": taskObj
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.reloadToolService.triggerToolSprint(this.modelData.tasks);
  }




  generateTaskDesc(type: any, eName: any, attribute: any, moduleName: any) {
    var description: any;
    if (type == 'pm') {
      description = "do Persona map";
    } else if (type == 'im') {
      description = "do Interaction map";
    } else if (type == 'sc') {
      description = "do Scope map";
    } else if (type == 'dd') {
      description = "do Deep dive ";
    } else if (type == 'de') {
      description = 'do Design for ' + attribute;
    } else if (type == 'ex') {
      description = 'do Retest ' + moduleName + ' | ' + eName + ' for ' + attribute;
    } else if (type == 'bex') {
      description = 'do reTest for ' + attribute;
    }
    return description;
  }


  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  deleteTasksByeutID(eID: any) {
    // for (var k = 0; k < this.modelData.tasks.length; k++) {
    //   if (this.modelData.tasks[k].entity_Id == eutID) {
    //     this.modelData.tasks.splice(k, 1);
    //     k--;
    //   }

    // }
    for (var k = 0; k < this.modelData.tasks.length; k++) {
      if (this.modelData.tasks[k].entity_Id == eID) {
        this.modelData.tasks.splice(k, 1);
        k--;
      }
    }
    for (var n = 0; n < this.modelData.tasks.length; n++) {
      if (this.modelData.tasks[n].primaryentity_Id != "") {
        if (this.modelData.tasks[n].primaryentity_Id == eID) {
          this.modelData.tasks.splice(n, 1);
          n--;
        }
      }
    }

    for (var l = 0; l < this.modelData.EUTdetails.length; l++) {
      if (this.modelData.EUTdetails[l].eID == eID) {
        this.modelData.EUTdetails.splice(l, 1);
        l--;
      }
    }

    for (var m = 0; m < this.modelData.interactionMap.length; m++) {
      if (this.modelData.interactionMap[m].eut2 == eID || this.modelData.interactionMap[m].eut1 == eID) {
        this.modelData.interactionMap.splice(m, 1);
        m--;
      }
    }
    // this.deleteEUT();
  }
  addNewEntity() {
    for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
      if (
        this.modelData.listOfEUTs[i].eName.toLowerCase() ==
        this.addNewEntityModel.toLowerCase() && this.modelData.listOfEUTs[i].mID == this.selectedmodule.mID
      ) {
        this.errorMessage = 'Already exists!';
        $('#duplicateErrorMessagePopupModel').modal('show');
        return;
      }
    }
    var newEntityObj = {
      //eid is the unique id generated for an entity,etype being the type ->tf,bf,fl
      eID: this.uniqueID(this.selectedAddEUT),
      eType: this.selectedAddEUT,
      eName: this.addNewEntityModel,
    };
    this.modelData.listOfEUTs.unshift(newEntityObj);
    this.addNewEntityModel = '';
    this.selectedAddEUT = 'TF'
  }

  deleteEntity() {
    this.syncModelDataObject = {
      "type": "ENTITY",
      "operation": "DELETE",
      "data": this.selectedEUT.eID
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
      if (this.modelData.listOfEUTs[j].eID == this.selectedEUT.eID) {
        // console.log(this.modelData.listOfEUTs[j]);
        // if (j >= 0) {
        this.modelData.listOfEUTs.splice(j, 1);
        // }
      }
    }

    $('#EUTDeleteConfirmModel').modal('hide');
    this.deleteTasksByeutID(this.selectedEUT.eID);
    this.selectedEUT = '';
    this.selectedEntity = '';
    this.entityName = '';
    this.choosenEUT = {};
    this.selectedEntityIDDetails = '';
    if (this.modelData.modules.length > 1) {
      this.selectModule(this.modelData.modules[1]);
    }
    this.selectModule(this.modelData.modules[0]);
    this.clear();
    return this.modelData.listOfEUTs;
    // this.taskPlannerComponent.loadPlanNamesList(this.modelData.tasks);
    // this.taskPlannerComponent.selectedPlan(false, false, '');
  }
  //generation of unique id for persona
  uniqueID(type: any) {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      type +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  // chooseEUT(eut: any) {
  //   this.selectedEUT = eut;
  //   this.entityName = eut.eName;
  //   console.log("this.selectedEUT", this.selectedEUT);
  //   this.getEUTdetails();
  // }


  getEUTdetails() {
    this.selectedEntity = this.modelData.EUTdetails.find(
      (eut: any) => eut.eID == this.selectedEUT.eID
    );
  }

  //handler to get the required details based on the selected entity
  loadEntityDetails(eutChosen: any) {
    this.mapText = '';
    this.editorContent = '';
    this.choosenEUT = eutChosen;
    window.localStorage.setItem('entityTestID', eutChosen.eID);
    this.selectedEntityIDDetails = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    if (this.selectedEntityIDDetails) {
      this.entityName = this.selectedEntityIDDetails.eName;
    }
    this.selectedEntity = this.modelData.EUTdetails.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    if (!this.selectedEntity) {
      this.addEntityDetails(eutChosen);
      this.selectedEntity = this.modelData.EUTdetails.find(
        (eut: any) => eut.eID == eutChosen.eID
      );

    } else {
      this.getMaps();
    }
    this.selectedEntityNotes = this.modelData.myNotes.find(
      (eut: any) => eut.eID == eutChosen.eID
    );
    // console.log("this.selectedEntity", this.selectedEntity);
    if (this.selectedEntity.notes != '') {
      this.notesEditorContent = this.selectedEntity.notes;
    } else {
      this.selectedEntity['notes'] = '';
    }
    // console.log("this.selectedEntityNotes", this.selectedEntityNotes);
    if (this.selectedEntityNotes != undefined) {
      if (this.selectedEntityNotes.notes) {
        this.designerNotesEditorContent = this.selectedEntityNotes.notes;
      } else {
        this.selectedEntityNotes['notes'] = '';
      }
    }
    this.selectedEUT = eutChosen;
    this.selectedEntityeID = eutChosen.eID;
    this.choosenEntityType = eutChosen.eType;
    this.chooseType(eutChosen.stage);
    this.EntityType = true;
    this.getMaps();
    if (eutChosen.base_eID != undefined) {
      this.choosenPrimaryEntity = this.modelData.listOfBaseEUTs.find(function (eut: any) {
        return eut.eID == eutChosen.base_eID;
      });
    }
    // console.log("this.choosenPrimaryEntity", this.choosenPrimaryEntity);
    // if (!this.choosenPrimaryEntity) {
    //   this.choosenPrimaryEntity = {
    //     "eName": '',
    //     "eID": ''
    //   };
    // }
    // eutChosen['mapText'] = this.mapText;
    window.localStorage.setItem('deepdiveSelected', JSON.stringify(eutChosen));

    setInterval(() => {
      window.localStorage.setItem('entityTestName', this.selectedEUT.eName);
      window.localStorage.setItem('entityTestID', this.selectedEUT.eID);
      if (this.selectedEntity) {
        window.localStorage.setItem('entityTestDescription', this.selectedEntity.bDescription);
      }
    }, 1000);
    this.scenariosStatus();
  }
  updateEntityDetails() {
    // alert("new");
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        this.modelData.EUTdetails[i]['bc'] = this.selectedEntity.bc;
        this.modelData.EUTdetails[i]['ac'] = this.selectedEntity.ac;
        this.modelData.EUTdetails[i]['outcomes'] = this.selectedEntity.outcomes;
        this.modelData.EUTdetails[i]['pIssues'] = this.selectedEntity.pIssues;
        this.modelData.EUTdetails[i]['bDescription'] = this.selectedEntity.bDescription;
        this.syncModelDataObject = {
          "type": "SPECS",
          "operation": "UPDATE",
          "data": this.modelData.EUTdetails[i]
        }
        this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }

  }
  clearEntityDetails() {
    this.choosenEUT = "";
    this.selectedEntityIDDetails = "";
    this.selectedEUT = "";
    this.selectedEntityeID = "";
    this.choosenEntityType = "";
    this.mapText = "";
    this.selectedEntity = "";
    window.localStorage.setItem("maptext", "");
    // this.chooseType(eutChosen.stage);
    this.EntityType = true;
  }
  //checks the current value of the check box for persona drop down
  //if true -> adds to the persona model
  //if false -> removes from the persona model
  mapEutToPerson(persona: any, isChecked: any) {
    isChecked
      ? this.addPer(persona, this.selectedEntity)
      : this.deletePer(persona, this.selectedEntity);
    this.getMaps();
    this.constructMapping();
  }
  addPer(persona: any, eut: any) {
    this.modelData.personaMap.push({ pType: persona, eID: eut.eID });
    this.syncModelDataObject = {
      "type": "PMAP",
      "operation": "CREATE",
      "data": { pType: persona, eID: eut.eID }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log('per', this.modelData.personaMap);
  }
  deletePer(persona: any, eut: any) {

    var index = this.modelData.personaMap.findIndex(
      (map: any) => map.eID == eut.eID && map.pType == persona
    );
    if (index > -1) {
      this.modelData.personaMap.splice(index, 1);
    }
    this.syncModelDataObject = {
      "type": "PMAP",
      "operation": "DELETE",
      "data": { pType: persona, eID: eut.eID }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }
  //checks the current value of the check box for attributes drop down
  //if true -> adds to the scope model
  //if false -> removes from the scope model
  mapEutToAtt(att: any, isChecked: any) {
    // console.log('checked', isChecked);
    isChecked
      ? this.addAttr(att, this.selectedEntity)
      : this.deleteAttr(att, this.selectedEntity);
    this.getMaps();
    this.constructMapping();
  }
  addAttr(att: any, eut: any) {
    this.modelData.scopeMap.push({
      aType: att,
      eID: eut.eID,
    });
    this.syncModelDataObject = {
      "type": "SMAP",
      "operation": "CREATE",
      "data": {
        aType: att,
        eID: eut.eID,
      }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    var attribute = this.Config.listOfAttributesUpdated.find(
      (attr: any) => attr.symbol == att
    );
    if (eut) {
      // console.log("eut",eut);
      var Task = this.modelData.tasks.find((task: any) => task.entity_Id == eut.eID);
      // console.log("Task",Task);
      this.generateTaskFromScope(Task, attribute);
      for (var i = 0; i < this.modelData.tasks.length; i++) {
        if (this.modelData.tasks[i].entity_Id == eut.eID) {
          if (this.modelData.tasks[i].toolType == 'pm' || this.modelData.tasks[i].toolType == 'im' || this.modelData.tasks[i].toolType == 'sc' || this.modelData.tasks[i].toolType == 'dd') {
            this.modelData.tasks[i]['attribute'] = attribute;
          }
        }
      }
    }
    this.checkAndUpdateTestTypeDescByEUT(att);
  }
  generateTaskFromScope(task: any, attribute: any) {
    // console.log("task", task);
    // console.log("attribute", attribute);
    let taskCreateArray = ['de', 'ex'];
    for (var i = 0; i < taskCreateArray.length; i++) {
      this.generateTaskObjScope(task, attribute, taskCreateArray[i]);
    }
  }
  generateTaskObjScope(task: any, attribute: any, toolType: any) {
    let taskObj: any = {};
    taskObj.task_combine_id = task.task_combine_id;
    taskObj.assignedto = task.assignedto;
    taskObj.assigneduser = task.assigneduser;
    taskObj.attribute = attribute;
    // taskObj.environment = this.model.choosenEntity.environment;
    taskObj.task_desc = this.generateTaskDesc(toolType, task.entity_desc, attribute.name, task.moduleName);
    taskObj.activity = { type: 'TN', name: 'Test', shortfrom: 'Test' };
    taskObj.toolType = toolType;
    taskObj.moduleName = task.moduleName;
    taskObj.moduleID = task.moduleID;
    taskObj.entity_Id = task.entity_Id;
    taskObj.entity_desc = task.entity_desc;
    taskObj.entityType = task.entityType;
    // taskObj.primaryentity_Id = this.model.choosenEntity.entity_Id;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.status = 1;
    taskObj.taskId = this.uuidv4();
    // taskObj.impactedUnquieID = impactedUnquieID;
    taskObj.createdOn = new Date();
    // console.log("taskObj", taskObj);
    this.modelData.tasks.push(taskObj);
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "CREATE",
      "data": taskObj
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.modelData.tasks", this.modelData.tasks);
  }
  deleteAttr(att: any, eut: any) {

    var index = this.modelData.scopeMap.findIndex(
      (map: any) => map.eID == eut.eID && map.aType == att
    );
    if (index > -1) {
      this.modelData.scopeMap.splice(index, 1);
    }
    this.syncModelDataObject = {
      "type": "SMAP",
      "operation": "DELETE",
      "data": { aType: att, eID: eut.eID }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      if (this.modelData.tasks[i].entity_Id == eut.eID && this.modelData.tasks[i].attribute.symbol == att && (this.modelData.tasks[i].toolType == 'de' || this.modelData.tasks[i].toolType == 'ex')) {
        this.modelData.tasks.splice(i, 1);
        i--;
      }
    }
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "SCOPE",
      "data": { aType: att, eID: eut.eID }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.deleteTestTypeDescByEUT(att);
  }

  checkAndUpdateTestTypeDescByEUT(att: any) {
    this.selectedTestType = { "symbol": att, "desc": '' };
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        if (this.modelData.EUTdetails[i].testTypes) {
          var Testtypeexists = this.modelData.EUTdetails[i].testTypes.find(
            (test: any) => test.symbol == att
          );
          if (Testtypeexists) {
            this.selectedTestType = Testtypeexists;
          } else {
            this.modelData.EUTdetails[i].testTypes.push(this.selectedTestType);
          }
        } else {
          this.modelData.EUTdetails[i]['testTypes'] = [this.selectedTestType];
        }
      }
    }
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "TESTTYPEDescAdd",
      "data": this.selectedTestType,
      "eut": this.selectedEntity
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.modelData.EUTdetails", this.modelData.EUTdetails);
    $('#testTypeDescModal').modal('show');
  }

  updateTestTypeDesc() {
    // console.log(this.selectedTestType);
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        for (var j = 0; j < this.modelData.EUTdetails[i].testTypes.length; j++) {
          if (this.modelData.EUTdetails[i].testTypes[j].symbol == this.selectedTestType.symbol) {
            this.modelData.EUTdetails[i].testTypes[j].desc = this.selectedTestType.desc;
            // return;
          }
        }
        // return;
      }
    };
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "TESTTYPEDescUpdate",
      "data": this.selectedTestType,
      "eut": this.selectedEntity
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.selectedTestType = { "symbol": '', "desc": '' };
    $('#testTypeDescModal').modal('hide');
    this.getMaps();
    this.constructMapping();
  }

  deleteTestTypeDescByEUT(att: any) {
    for (var i = 0; i < this.modelData.EUTdetails.length; i++) {
      if (this.modelData.EUTdetails[i].eID == this.selectedEntity.eID) {
        for (var j = 0; j < this.modelData.EUTdetails[i].testTypes.length; j++) {
          if (this.modelData.EUTdetails[i].testTypes[j].symbol == att) {
            this.modelData.EUTdetails[i].testTypes.splice(j, 1);
          }
        }
      }
    }
    this.syncModelDataObject = {
      "type": "SPECS",
      "operation": "TESTTYPEDescDelete",
      "data": att,
      "eut": this.selectedEntity
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.getMaps();
    this.constructMapping();
  }

  addEntityDetails(eut: any) {
    this.modelData.EUTdetails.push({
      eID: eut.eID,
      bc: '',
      ac: '',
      outcomes: '',
      bDescription: '',
      pIssues: '',
      notes: this.config.entityDefaultNotes
    });

  }
  //handler that access the model functions to return the related mapping details based on chosen eutID
  getMaps() {
    if (this.selectedEntity) {
      this.persona = this.getPersonaForAnEut(this.selectedEntity);
      this.attribute = this.getScopeForAnEut(this.selectedEntity);
      this.interaction = this.getInteractionMappingForAnEut(
        this.selectedEntity
      );
      this.constructMapping();
    }
  }
  getPersonaForAnEut(eut: any) {
    var mappedPersonaForEut = this.modelData.personaMap.filter(
      (map: any) => map.eID == eut.eID
    );
    return mappedPersonaForEut;
  }
  getScopeForAnEut(eut: any) {
    var mappedScopeForEut = this.modelData.scopeMap.filter(
      (map: any) => map.eID == eut.eID
    );
    return mappedScopeForEut;
  }
  getInteractionMappingForAnEut(eut: any) {
    var mappedInteractionForEut = this.modelData.interactionMap.filter(
      (map: any) => map.eut1 == eut.eID
    );
    return mappedInteractionForEut;
  }
  //checks the current value of the check box for interactions drop down
  //if true -> adds to the interaction model
  //if false -> removes from the interaction model
  mapEutToEut(eut: any, isChecked: any) {
    isChecked
      ? this.addEUT(eut, this.selectedEntity)
      : this.deleteEUT(eut, this.selectedEntity);
    this.getMaps();
    this.constructMapping();
  }
  addEUT(eID: any, eut: any) {
    // console.log(eID, eut);
    this.modelData.interactionMap.push({ eut2: eID, eut1: eut.eID });
    this.syncModelDataObject = {
      "type": "IMAP",
      "operation": "CREATE",
      "data": { eut1: eut.eID, eut2: eID }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log('Imap', this.modelData.interactionMap);
    var eut = this.modelData.listOfEUTs.find((eut: any) => eut.eID == eID);
    if (eut) {
      var Task = this.modelData.tasks.find((eut: any) => (eut.entity_Id == eID));
      this.generateTaskObjInteract(Task, eut, eut.eID, 'ex');
    }
  }

  deleteEUT(eID: any, eut: any) {
    var index = this.modelData.interactionMap.findIndex(
      (map: any) => map.eut1 == eut.eID && map.eut2 == eID
    );

    if (index > -1) {
      this.modelData.interactionMap.splice(index, 1);
    }
    this.syncModelDataObject = {
      "type": "IMAP",
      "operation": "DELETE",
      "data": { eut1: eut.eID, eut2: eID }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    this.deleteInteractTask(eID, eut.eID);
  }

  deleteInteractTask(eID: any, eutID: any) {
    // console.log("task", eID);
    // console.log("entity", eutID);
    for (var i = 0; i < this.modelData.tasks.length; i++) {
      if (this.modelData.tasks[i].entity_Id == eID && this.modelData.tasks[i].toolType == 'ex' && this.modelData.tasks[i].primaryentity_Id == eutID) {
        // console.log(this.modelData.tasks[i]);
        this.modelData.tasks.splice(i, 1);
        i--;
      }
    }
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "INTERACT",
      "data": { entity_Id: eID, primaryentity_Id: eutID }
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }
  generateTaskObjInteract(task: any, entity: any, primaryEUTId: any, toolType: any) {
    let taskObj: any = {};
    var attribute: any = {};
    if (entity.eType == "TF" || entity.eType == "XX") {
      attribute = {
        name: "Feature Behaviour",
        symbol: "Fe",
        level: "L4"
      };
    } else if (entity.eType == "UR") {
      attribute = {
        name: "Requirement Behaviour",
        symbol: "Rb",
        level: "L5"

      };
    } else if (entity.eType == "BF") {
      attribute = {
        name: "Flow Behaviour",
        symbol: "Fb",
        level: "L5"
      };
    }
    taskObj.task_combine_id = this.uuidv4();
    taskObj.assignedto = task.assignedto;
    taskObj.assigneduser = task.assigneduser;
    taskObj.attribute = attribute;
    taskObj.activity = { type: 'RI', name: 'Re-test', shortfrom: 'R-Test' };
    // taskObj.environment = this.model.choosenEntity.environment;
    taskObj.task_desc = this.generateTaskDesc(toolType, entity.eName, attribute.name, task.moduleName);
    taskObj.toolType = toolType;
    taskObj.moduleName = task.moduleName;
    taskObj.moduleID = task.moduleID;
    taskObj.entity_Id = entity.eID;
    taskObj.entity_desc = entity.eName;
    taskObj.entityType = entity.eType;
    taskObj.primaryentity_Id = primaryEUTId;
    taskObj.completed = false;
    taskObj.history = false;
    taskObj.checked = false;
    taskObj.status = 1;
    taskObj.taskId = this.uuidv4();
    // taskObj.impactedUnquieID = impactedUnquieID;
    taskObj.createdOn = new Date();
    // console.log("taskObj", taskObj);
    this.modelData.tasks.push(taskObj);
    this.syncModelDataObject = {
      "type": "TASK",
      "operation": "CREATE",
      "data": taskObj
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("this.modelData.tasks", this.modelData.tasks);
  }
  //Check whether the persona in list is present in the persona mapping for the choosen eut
  isChecked(persona: any) {
    if (this.persona.length > 0) {
      var p = this.persona.findIndex((p: any) => p.pType == persona);
      return p > -1 ? true : false;
    } else {
      return false;
    }
  }

  //Check whether the attribute in list is present in the scope map for the choosen eut
  isCheckedAtt(attribute: any) {
    if (this.attribute.length > 0) {
      var a = this.attribute.findIndex((a: any) => a.aType == attribute.symbol);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }

  //Check whether the eut in list is present in the interaction mapping for the choosen eut
  isCheckedInter(eut: any) {
    if (this.interaction.length > 0) {
      var a = this.interaction.findIndex((a: any) => a.eut2 == eut.eID);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }

  //contruct a string that contain the peronas mapped, attributes mapped and the interaction with other euts
  constructMapping() {
    // var this = this;
    this.mapText = '';
    if (this.persona.length > 0 && this.modelData.persona.length > 0) {
      //check if persona exits in list of persona
      // var ptype = this.model.persona.map(p => p.pType);
      // var found = this.persona.some(p => ptype.indexOf(p.pType) >= 0);
      var found = '';
      // if (found) {
      this.mapText += 'The list of personas are :\n';

      for (var i = 0; i < this.persona.length; i++) {
        if (i < this.persona.length - 1) {
          if (this.persona[i].pType) {
            // console.log("this.persona[i]", this.persona[i]);
            // console.log(this.modelData.persona);
            var personaName = this.modelData.persona.find(
              (p: any) => p.pType == this.persona[i].pType
            );
            // console.log("personaName", personaName);
            if (personaName) {
              this.mapText += personaName.pName + ',';
            }
          }

        } else {
          if (this.persona[i].pType) {
            var personaName = this.modelData.persona.find(
              (p: any) => p.pType == this.persona[i].pType
            );
            if (personaName) {
              this.mapText += personaName.pName + ',';
            }
          }
        }
      }
      this.mapText = this.mapText.slice(0, -1);
      this.mapText += '\n';
      this.mapText += '--------------------------------------\n';
    }
    // console.log("this.selectedEntity",this.selectedEntity);
    this.mappedAttributes = this.modelData.EUTdetails.find(
      (details: any) => details.eID == this.selectedEntity.eID
    );
    // console.log("mappedAttributes",this.mappedAttributes.testTypes);
    if (this.mappedAttributes.testTypes) {
      if (this.mappedAttributes.testTypes.length > 0) {
        this.mapText += 'To satisfy the list of attributes :\n';
        for (var j = 0; j < this.mappedAttributes.testTypes.length; j++) {
          var attName = this.config.listOfAttributesUpdated.find(
            (a: any) => a.symbol == this.mappedAttributes.testTypes[j].symbol
          );
          // console.log("attName", attName);
          if (attName) {
            // var desc = "";
            // console.log("attName", attName.symbol);
            // var testType = this.getAttributeDescription(attName.symbol);
            // console.log("testType", testType);
            // if (j < this.attribute.length - 1) {
            //   console.log("Attrdesc",testType);
            // var desc = "";
            // if (!attName) {
            //   this.mapText += attName.name + ': ' + desc + '\n';
            // } else {
            this.mapText += attName.name + ': ' + this.mappedAttributes.testTypes[j].desc + '\n';
            // }

            // } else {
            //   this.mapText += attName.name + ': ' + desc
            // }
          }
        }
        this.mapText += '\n';
        this.mapText += '--------------------------------------\n';
      }
    }
    if (this.interaction.length > 0) {
      this.mapText += 'Interacts with:\n';
      for (var i = 0; i < this.interaction.length; i++) {
        var eut1 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut1
        );
        var eut2 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut2
        );
        if (eut1 && eut2) {
          if (eut1.eType == 'TF') {
            if (eut1.eType == eut2.eType) {
              // if (i < this.interaction.length - 1) {
              var moduleName = this.getModuleName(eut2);
              this.mapText += moduleName + ' | ' + eut2.eName + ', ';
              // } else {
              //     this.mapText += eut2.eName;
              // }
            }
          }
        }
      }
      this.mapText = this.mapText.slice(0, -1);
      this.mapText += '\n';
      this.mapText += 'Used by:\n';
      for (var i = 0; i < this.interaction.length; i++) {
        var eut1 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut1
        );
        var eut2 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut2
        );
        if (eut1 && eut2) {
          if (eut1.eType != eut2.eType) {
            // if (i < this.interaction.length - 1) {
            var moduleName = this.getModuleName(eut2);
            this.mapText += moduleName + ' | ' + eut2.eName + ', ';
            // } else {
            //     this.mapText += eut2.eName;
            // }
          }
        }
      }
      this.mapText = this.mapText.slice(0, -1);
      this.mapText += '\n';
      this.mapText += '--------------------------------------\n';
    }
    this.constructMappingForCoverage();
  }

  constructMappingForCoverage() {
    // var this = this;
    this.mapTextCoverage = '<html>';
    if (this.persona.length > 0 && this.modelData.persona.length > 0) {
      //check if persona exits in list of persona
      // var ptype = this.model.persona.map(p => p.pType);
      // var found = this.persona.some(p => ptype.indexOf(p.pType) >= 0);
      var found = '';
      // if (found) {
      this.mapTextCoverage += '<div>';
      this.mapTextCoverage += '<b>The list of personas are :</b>\n';
      this.mapTextCoverage += '<ul>';

      for (var i = 0; i < this.persona.length; i++) {
        if (i < this.persona.length - 1) {
          if (this.persona[i].pType) {
            // console.log("this.persona[i]", this.persona[i]);
            // console.log(this.modelData.persona);
            var personaName = this.modelData.persona.find(
              (p: any) => p.pType == this.persona[i].pType
            );
            // console.log("personaName", personaName);
            if (personaName) {
              this.mapTextCoverage += '<li>' + personaName.pName + '</li>';
            }
          }

        } else {
          if (this.persona[i].pType) {
            var personaName = this.modelData.persona.find(
              (p: any) => p.pType == this.persona[i].pType
            );
            if (personaName) {
              this.mapTextCoverage += '<li>' + personaName.pName + '</li>';
            }
          }
        }
      }
      this.mapTextCoverage = this.mapTextCoverage.slice(0, -1);
      this.mapTextCoverage += '</ul>';
      this.mapTextCoverage += '</div>';
      // this.mapTextCoverage += '--------------------------------------\n';
    }
    // console.log("this.selectedEntity",this.selectedEntity);
    this.mappedAttributes = this.modelData.EUTdetails.find(
      (details: any) => details.eID == this.selectedEntity.eID
    );
    // console.log("mappedAttributes",this.mappedAttributes.testTypes);
    if (this.mappedAttributes.testTypes) {
      if (this.mappedAttributes.testTypes.length > 0) {
        this.mapTextCoverage += '<div>';
        this.mapTextCoverage += '<b>To satisfy the list of attributes :</b>\n';
        this.mapTextCoverage += '<ul>';
        for (var j = 0; j < this.mappedAttributes.testTypes.length; j++) {
          var attName = this.config.listOfAttributesUpdated.find(
            (a: any) => a.symbol == this.mappedAttributes.testTypes[j].symbol
          );
          if (attName) {
            this.mapTextCoverage += '<li>' + attName.name + ': ' + this.mappedAttributes.testTypes[j].desc + '</li>';
          }
        }
        this.mapTextCoverage += '</ul>';
        this.mapTextCoverage += '</div>';
        // this.mapTextCoverage += '\n';
        // this.mapTextCoverage += '--------------------------------------\n';
      }
    }
    if (this.interaction.length > 0) {
      this.mapTextCoverage += '<div>';
      this.mapTextCoverage += '<b>Interacts with:</b>\n';
      this.mapTextCoverage += '<ul>';
      for (var i = 0; i < this.interaction.length; i++) {
        var eut1 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut1
        );
        var eut2 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut2
        );
        if (eut1 && eut2) {
          if (eut1.eType == 'TF') {
            if (eut1.eType == eut2.eType) {
              var moduleName = this.getModuleName(eut2);
              this.mapTextCoverage += '<li>' + moduleName + ' | ' + eut2.eName + '</li>';
            }
          }
        }
      }
      this.mapTextCoverage = this.mapTextCoverage.slice(0, -1);
      this.mapTextCoverage += '</ul>';
      this.mapTextCoverage += '</div>';
      // this.mapTextCoverage += '<br>';
      this.mapTextCoverage += '<div>';
      this.mapTextCoverage += '<b>Used by:</b>\n';
      this.mapTextCoverage += '<ul>';
      for (var i = 0; i < this.interaction.length; i++) {
        var eut1 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut1
        );
        var eut2 = this.modelData.listOfEUTs.find(
          (eut: any) => eut.eID == this.interaction[i].eut2
        );
        if (eut1 && eut2) {
          if (eut1.eType != eut2.eType) {
            // if (i < this.interaction.length - 1) {
            var moduleName = this.getModuleName(eut2);
            this.mapTextCoverage += '<li>' + moduleName + ' | ' + eut2.eName + '</li>';
            // } else {
            //     this.mapTextCoverage += eut2.eName;
            // }
          }
        }
      }
      this.mapTextCoverage = this.mapTextCoverage.slice(0, -1);
      this.mapTextCoverage += '</ul>';
      this.mapTextCoverage += '</div>';
      this.mapTextCoverage += '</html>';
    }
    window.localStorage.setItem("mapTextCoverage", this.mapTextCoverage);
  }
  getAttributeDescription(symbol: any) {
    // console.log("this.selectedEntity", this.selectedEntity, symbol);
    if (this.selectedEntity.testTypes) {
      let matchedItem = this.selectedEntity.testTypes.find(
        (att: any) => att.symbol == symbol
      );
      // console.log("matchedItem", matchedItem);
      return matchedItem;
    }
  }
  blur(event: Focus) {
    var foundNotes = false;
    let notesObject;
    if (this.selectedEntity.eID) {
      if (this.modelData.myNotes.length > 0) {
        for (var i = 0; i < this.modelData.myNotes.length; i++) {
          if (this.modelData.myNotes[i].eID == this.selectedEntity.eID) {
            this.modelData.myNotes[i]['notes'] = this.editorContent;
            foundNotes = true;
            this.syncModelDataObject = {
              "type": "NOTES",
              "operation": "UPDATE",
              "data": this.selectedEntity,
              "notes": this.editorContent
            }
            this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
          }
        }
        if (foundNotes == false) {
          notesObject = {
            "eID": this.selectedEntity.eID,
            "notes": this.editorContent
          }
        }
      } else {
        notesObject = {
          "eID": this.selectedEntity.eID,
          "notes": this.editorContent
        }
      }
      if (notesObject != null) {
        this.modelData.myNotes.push(notesObject);
        this.syncModelDataObject = {
          "type": "NOTES",
          "operation": "CREATE",
          "data": notesObject
        }
        this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
      // console.log(this.modelData.myNotes);
    }
  }

  editorChanged(event: EditorChangeContent | EditorChangeSelection) {
    this.editorContent = event['editor']['root']['innerHTML'];
    this.editorContentText = event['editor']['root']['innerText'];
    // console.log('Changed', event);
    if (event['event'] == 'selection-change') {
      var range: any = event['range'];
      this.selectedString = '';
      var text = event.editor.getText(range['index'], range['length']);
      // console.log("text",text);
      // console.log('text1', this.editorContentText);
      // console.log('index', this.editorContentText.replace(/\r?\n|\r/, ''));
      // var newText = this.editorContentText.replace(/\s+/g, '');
      // console.log('tt', newText.substr(range['index'], range['length']));
      this.selectedString = text.split('\n');
      // this.selectedString = cleanArray.filter(function (el: any) {
      //   return el != null;
      // });
      this.selectedString = this.selectedString.filter((item: any) => item);
      // console.log('text', this.selectedString);
    } else {
      // console.log("this.selectedEntity", this.selectedEntity);
      this.selectedEntity['notes'] = this.editorContent;
      // console.log("this.selectedEntity", this.selectedEntity);
      // var token = window.localStorage.getItem('publicToken');
      // var projectID = window.localStorage.getItem('projectID');
      // var userID = window.localStorage.getItem('userID');
      // var jsonObjects = {
      //   projectId: projectID,
      //   userID: userID,
      //   content: this.editorContent,
      // };
      // this.ProjectServices.addMynotesEditorContent(jsonObjects).subscribe(
      //   (response: any) => {
      //     console.log('res', response);
      //     if (response.statusCode == 200) {
      //       // this.quillEditorContent = response.record.content;
      //     } else {
      //     }
      //   }
      // );
    }
  }

  designereditorChanged(event: EditorChangeContent | EditorChangeSelection) {
    this.designereditorContent = event['editor']['root']['innerHTML'];
    this.designereditorContentText = event['editor']['root']['innerText'];
    if (event['event'] == 'selection-change') {
      var range: any = event['range'];
      this.designerselectedString = '';
      var text = event.editor.getText(range['index'], range['length']);

      this.designerselectedString = text.split('\n');

      this.designerselectedString = this.designerselectedString.filter((item: any) => item);
    } else {
      // console.log("this.selectedEntity", this.selectedEntity);
      this.selectedEntity['designerNotes'] = this.designereditorContent;
      // console.log("this.selectedEntity", this.selectedEntity);
    }
  }

  resetFilters() {
    this.attributeSelected = [];
    this.crSelected = [];
  }

  scenarioAddReset() {
    // this.newscenarioattr = 'Feature Behaviour';
    // this.newscenariosymbol = 'Fe';
    this.newscenariocr = '+';
    this.newscenariopriority = '1';
    this.newscenariodesc = '';
    this.editscenariodesc = '';
    // this.newscenariopersona = [];
    this.editScenario = '';
    // this.newscenariolevel = '';
    this.selectTest(this.config.listofFunctionalityTestTypes[0]);
    $('#designerScenTextarea').val('');
  }
  // function is used for level filter
  addToLevelFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.levelSelected.push(id);
    } else {
      var isPresent = this.levelSelected.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.levelSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('Level', this.levelSelected);
  }
  // function is used for attr filter
  addToAttributeFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.attributeSelected.push(id);
    } else {
      var isPresent = this.attributeSelected.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.attributeSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('Attr', this.attributeSelected);
  }

  // function is used for priority & cr filter
  addToCrFilter(cr: any, isChecked: any) {
    if (isChecked) {
      this.crSelected.push(cr);
    } else {
      var isPresent = this.crSelected.findIndex((value: any) => value == cr);
      if (isPresent > -1) {
        this.crSelected.splice(isPresent, 1);
      }
    }
    this.scenarioAddReset();
    // console.log('CR', this.crSelected);
  }

  selectTest(test: any) {
    // this.newscenariolevel = test;
    this.newscenariosymbol = test.symbol;
    this.selectedTest = test;
    // this.selectedTestName = test.name;
    this.newscenariolevel = test.level;
    // var symbol = test.symbol;
    // if (symbol == 'Mi' || symbol == 'In' || symbol == 'Co' || symbol == 'Si') {
    //   this.newscenariolevel = 'L8';
    // } else if (symbol == 'Pf' || symbol == 'Lo' || symbol == 'Re' || symbol == 'Se' || symbol == 'Us') {
    //   this.newscenariolevel = 'L7';
    // } else if (symbol == 'Bc' || symbol == 'Ec') {
    //   this.newscenariolevel = 'L6';
    // } else if (symbol == 'Rb' || symbol == 'Fb') {
    //   this.newscenariolevel = 'L5';
    // } else if (symbol == 'Ac' || symbol == 'Fe') {
    //   this.newscenariolevel = 'L4';
    // } else if (symbol == 'Ui' || symbol == 'St' || symbol == 'Dt') {
    //   this.newscenariolevel = 'L123';
    // } else {
    //   this.newscenariolevel = '';
    // }
  }

  selectType(type: any) {
    this.newscenariocr = type;
  }


  CreateScenario() {
    // console.log(this.newscenarioattr);
    // console.log(this.newscenariosymbol);
    // console.log(this.newscenariodesc);
    // console.log(this.newscenariocr);
    // console.log(this.newscenariopriority);
    // console.log(this.newscenariopersona);
    this.newscenariodesc = this.editscenariodesc;
    if (this.editScenario) {
      // console.log('edit', this.newscenariodesc);
      if (this.newscenariodesc != '') {
        this.updateScenario(
          this.editScenario.scenID,
          this.newscenariosymbol,
          this.newscenariocr,
          this.newscenariopriority,
          this.selectedTest,
          this.newscenariodesc
        );
        this.scenarioAddReset();
      } else {
        this.message = 'Would you like to delete?';
        $('#deleteScenarioConfirmPopupModel').modal('show');
      }
    } else {
      if (this.newscenariodesc != '') {
        this.addScenario(
          this.newscenariodesc,
          this.selectedEntity.eID,
          this.newscenariosymbol,
          '-1',
          'E',
          this.newscenariocr,
          this.selectedTest,
          this.newscenariopriority,
        );
        this.scenarioAddReset();
        $('#designerScenTable tr').removeClass('active');
      } else {
        this.newscenariodesc = '';
        this.editscenariodesc = '';
        $('#emptyScenAddErrorPopup').modal('show');
      }
    }
  }
  editScenarioData(scenario: any) {
    // console.log("scenario",scenario);
    this.editScenario = scenario;
    this.editscenariodesc = scenario.description;
    // this.newscenariopersona = scenario.persona;
    // let matchedItem = this.config.listOfAttributesUpdated.find(
    //   (att: any) => att.symbol == scenario.tID
    // );
    // if (matchedItem) {
    //   console.log(matchedItem);
    //   this.newscenariosymbol = matchedItem.symbol;
    //   this.newscenarioattr = matchedItem.name;
    // }
    // this.newscenariopriority = scenario.priority;
    this.newscenariocr = scenario.cr;
    this.selectTest(scenario.attribute);
    // this.newscenariolevel = scenario.level;
  }
  deleteScenarioModal(editscenariodesc: any) {
    if (editscenariodesc != '') {
      this.message = 'Would you like to delete?';
      $('#deleteScenarioConfirmPopupModel').modal('show');
    } else {
      this.newscenariodesc = '';
      this.scenarioEmpty = "Scenario can't be empty.";
      $('#emptyScenAddErrorPopup').modal('show');
    }

  }
  addScenario(
    newScenario: any,
    eID: any,
    tID: any,
    id: any,
    sType: any,
    cr: any,
    attribute: any,
    priority: any,
  ) {
    var scenario = {
      EorT: sType,
      scenID: this.uniqueSCID(),
      description: newScenario,
      eID: eID,
      tID: tID,
      priority: priority || '1',
      cr: cr || '+',
      attribute: attribute,
    };

    // for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
    //   if (this.modelData.listOfEUTs[i].eID == eID) {
    //     this.modelData.listOfEUTs[i].scenarioCount++;
    //   }
    // }
    var newID = id + 1;
    // console.log("scenario", scenario);
    this.modelData.scenarios.unshift(scenario);
    this.syncModelDataObject = {
      "type": "SCENARIO",
      "operation": "CREATE",
      "data": scenario
    }
    this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
  }
  updateScenario(
    scenID: any,
    attr: any,
    cr: any,
    pri: any,
    attribute: any,
    desc: any
  ) {
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (this.modelData.scenarios[i].scenID == scenID) {
        this.modelData.scenarios[i].tID = attr;
        this.modelData.scenarios[i].cr = cr;
        this.modelData.scenarios[i].priority = pri;
        this.modelData.scenarios[i].attribute = attribute;
        this.modelData.scenarios[i].description = desc;
        this.syncModelDataObject = {
          "type": "SCENARIO",
          "operation": "UPDATE",
          "data": this.modelData.scenarios[i]
        }
        this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }
  }

  deleteScenarioByEdit() {
    if (this.editScenario) {
      this.delete(this.editScenario.scenID);
      this.scenarioAddReset();
    }
  }
  delete(scenID: any) {
    // console.log("sc",scenID);
    // if (id >= 0) {
    // console.log("scen", this.scenarios[id]);
    for (var i = 0; i < this.modelData.scenarios.length; i++) {
      if (scenID == this.modelData.scenarios[i].scenID) {
        // console.log("sc1",this.scenarios[i]);
        this.selectedDeleteScenEid = this.modelData.scenarios[i].eID;
        this.modelData.scenarios.splice(i, 1);
        this.syncModelDataObject = {
          "type": "SCENARIO",
          "operation": "DELETE",
          "data": this.editScenario
        }
        this.MainComponent.updateActiveUsersModel(this.syncModelDataObject);
      }
    }
    // console.log("scccc",this.scenarios);
    this.deleteScenarioByID(scenID);
    for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
      if (this.modelData.listOfEUTs[j].eID == this.selectedDeleteScenEid) {
        this.modelData.listOfEUTs[j].scenarioCount--;
      }
    }
    //   return this.scenarios.splice(id, 1);
    // }
  }
  deleteScenarioByID(scenID: any) {
    // console.log("scen", scenario.scenID);
    if (scenID) {
      for (var i = 0; i < this.modelData.runInfo.length; i++) {
        if (scenID == this.modelData.runInfo[i].scenID) {
          this.modelData.runInfo.splice(i, 1);
          i--;
        }
      }
      for (var j = 0; j < this.modelData.suites.length; j++) {
        for (var k = 0; k < this.modelData.suites[j].scenarios.length; k++) {
          if (scenID == this.modelData.suites[j].scenarios[k]) {
            this.modelData.suites[j].scenarios.splice(k, 1);
            break;
          }
        }
      }
    }
  }

  //generation of unique id for an scenario
  uniqueSCID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      'SC' +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }
  selectEditorLevel(attr: any) {
    // this.selectedEditorLevel = level;
    this.selectedEditorAttribute = attr;
  }
  checkQuillSelection() {
    // console.log('Attr', this.selectedEditorAttribute.symbol);
    // console.log('List', this.designerselectedString);
    // console.log('EUT', this.selectedEntity);
    if (this.selectedEntity.eID) {
      for (var i = 0; i < this.designerselectedString.length; i++) {
        this.matchedScenario = this.modelData.scenarios.find(
          (scen: any) =>
            scen.description == this.designerselectedString[i] &&
            scen.eID == this.selectedEntity.eID &&
            scen.tID == this.selectedTest.symbol
        );
        if (!this.matchedScenario) {
          // if (this.designerselectedString[i]) {
          this.addScenario(
            this.designerselectedString[i],
            this.selectedEntity.eID,
            this.selectedTest.symbol,
            '-1',
            'E',
            '+',
            this.selectedTest,
            '1'
          );
          this.errorMessage = "Scenarios added successfully";
          $('#duplicateErrorMessagePopupModel').modal('show');
        } else {
          this.errorMessage = "Scenario already exists";
          this.duplicateScenario = "'" + this.matchedScenario.description + "'";
          $("#duplicateScenarioErrorPopupModelDesigner").modal("show");
        }
      }
    } else {
    }
  }

  generateMindMap() {
    this.MainComponent.sendJson(this.selectedEntityIDDetails)
  }
  getEntityType(eID: any) {
    var index = this.modelData.listOfEUTs.find((eut: any) => eut.eID == eID)
    if (index) {
      return index.eType
    } else {
      return '';
    }
  }
  htmlToTextWithLineBreaks(htmlString: any) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Replace <br> tags with newline characters
    const brTags = tempDiv.querySelectorAll('br');
    brTags.forEach(br => {
      if (br.parentNode) {
        const newLine = document.createElement('p');
        br.parentNode.replaceChild(newLine, br);
      }
    });

    // Replace <p> tags with newline characters
    const pTags = tempDiv.querySelectorAll('p');
    pTags.forEach(p => {
      p.outerHTML = '\n' + p.innerHTML + '\n';
    });

    return tempDiv.textContent || tempDiv.innerText || '';
  }

}


